import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'bootstrap/dist/css/bootstrap.css';
import './styles/tokens.css';
import './index.css';
import './styles/theme-dark.css';
import './i18n/rtl.css';
import './styles/theme-light.css';
import { applyDocumentLanguage } from './i18n';
import { applyTheme, getTheme } from './theme';
import { applyScale, getScaleSetting } from './display';

applyDocumentLanguage();
applyTheme(getTheme());
applyScale(getScaleSetting());

ReactDOM.render(
  // <React.StrictMode>
    <App />,
    // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Registers /service-worker.js in production builds - required (along with
// manifest.json) for the browser to consider this site installable and
// fire the beforeinstallprompt event that InstallAppPrompt listens for.
serviceWorkerRegistration.register();